import { put, call, takeLatest } from 'redux-saga/effects';

import AuthUtil from '../../AuthUtil';
import { ONBOARDING } from '../../../components/global/Server/endpoints';
import { showErrorMessage } from '../../actions/global';
import { SERVER_FAILED_ERROR_MESSAGE } from '../../../pages/Dashboard/constants';
import {
  LIST_ONBOARDING_REQUESTS,
  UPDATE_ONBOARDING_REQUEST,
  ACTIVATE_ONBOARDING_REQUEST,
  SEND_ONBOARDING_WELCOME,
} from '../../constants/onboarding';
import {
  storeOnboardingRequests,
  listOnboardingRequests,
} from '../../actions/onboarding';

function* listOnboardingRequestsSaga(action) {
  try {
    const response = yield call(() =>
      AuthUtil.postRequest(ONBOARDING.LIST_REQUESTS, action.data || {})
    );
    if (response.status === 200 && response.data.success) {
      yield put(storeOnboardingRequests(response.data.requests));
    } else {
      yield put(
        showErrorMessage(response.data?.message || SERVER_FAILED_ERROR_MESSAGE)
      );
    }
  } catch (error) {
    yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
  }
}

function* updateOnboardingRequestSaga(action) {
  try {
    const response = yield call(() =>
      AuthUtil.postRequest(ONBOARDING.UPDATE_REQUEST, action.data)
    );
    const ok = response.status === 200 && response.data.success;
    if (ok) {
      yield put(listOnboardingRequests({}));
    } else {
      yield put(
        showErrorMessage(response.data?.message || SERVER_FAILED_ERROR_MESSAGE)
      );
    }
    if (action.callback) action.callback(ok, response.data);
  } catch (error) {
    yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    if (action.callback) action.callback(false, null);
  }
}

function* activateOnboardingRequestSaga(action) {
  try {
    const response = yield call(() =>
      AuthUtil.postRequest(ONBOARDING.ACTIVATE, action.data)
    );
    const ok = response.status === 200 && response.data.success;
    if (ok) {
      yield put(listOnboardingRequests({}));
    } else {
      yield put(
        showErrorMessage(response.data?.message || SERVER_FAILED_ERROR_MESSAGE)
      );
    }
    if (action.callback) action.callback(ok, response.data);
  } catch (error) {
    yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    if (action.callback) action.callback(false, null);
  }
}

function* sendOnboardingWelcomeSaga(action) {
  try {
    const response = yield call(() =>
      AuthUtil.postRequest(ONBOARDING.SEND_WELCOME, action.data)
    );
    const ok = response.status === 200 && response.data.success;
    if (ok) {
      // Refresh so the persisted welcomeSentAt timestamp shows up immediately.
      yield put(listOnboardingRequests({}));
    } else {
      yield put(
        showErrorMessage(response.data?.message || SERVER_FAILED_ERROR_MESSAGE)
      );
    }
    if (action.callback) action.callback(ok, response.data);
  } catch (error) {
    yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    if (action.callback) action.callback(false, null);
  }
}

export default function* onboardingSagas() {
  yield takeLatest(LIST_ONBOARDING_REQUESTS, listOnboardingRequestsSaga);
  yield takeLatest(UPDATE_ONBOARDING_REQUEST, updateOnboardingRequestSaga);
  yield takeLatest(ACTIVATE_ONBOARDING_REQUEST, activateOnboardingRequestSaga);
  yield takeLatest(SEND_ONBOARDING_WELCOME, sendOnboardingWelcomeSaga);
}
